import React from 'react';
import { ArrowRight, Clock, User } from 'lucide-react';
import { BlogPost } from '../../data/blogPosts';

interface BlogCardProps {
    post: BlogPost;
    onClick: (slug: string) => void;
}

export const BlogCard: React.FC<BlogCardProps> = ({ post, onClick }) => {
    return (
        <div
            onClick={() => onClick(post.slug)}
            className="group cursor-pointer flex flex-col bg-white dark:bg-slate-900 rounded-2xl overflow-hidden border border-slate-200 dark:border-slate-800 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 h-full"
        >
            <div className="relative h-48 w-full overflow-hidden">
                <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4 flex gap-2">
                    {post.tags.map(tag => (
                        <span key={tag} className="px-3 py-1 text-xs font-semibold bg-white/90 dark:bg-slate-900/90 backdrop-blur-sm rounded-full text-slate-800 dark:text-white shadow-sm">
                            {tag}
                        </span>
                    ))}
                </div>
            </div>

            <div className="flex flex-col flex-1 p-6">
                <div className="flex items-center gap-4 text-xs text-slate-500 dark:text-slate-400 mb-3">
                    <span className="flex items-center gap-1">
                        <User className="w-3 h-3" />
                        {post.author}
                    </span>
                    <span className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {post.readTime}
                    </span>
                    <span className="text-slate-300 dark:text-slate-700">•</span>
                    <span>{post.date}</span>
                </div>

                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                    {post.title}
                </h3>

                <p className="text-slate-600 dark:text-slate-300 text-sm line-clamp-3 mb-6 flex-1">
                    {post.excerpt}
                </p>

                <div className="flex items-center text-sm font-semibold text-indigo-600 dark:text-indigo-400 group-hover:gap-2 transition-all">
                    Read Article
                    <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
                </div>
            </div>
        </div>
    );
};
